import { render, staticRenderFns } from "./SidebarPanel.vue?vue&type=template&id=e113647e&scoped=true"
import script from "./SidebarPanel.vue?vue&type=script&lang=ts"
export * from "./SidebarPanel.vue?vue&type=script&lang=ts"
import style0 from "./SidebarPanel.vue?vue&type=style&index=0&id=e113647e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e113647e",
  null
  
)

export default component.exports